import { Container } from "components/Page"
import GlobalMediaTypes from "../GlobalMediaTypes"
import { useAgencyId } from "hooks/useAgencyId"

function AgencyMediaTypes() {
  const { agencyId } = useAgencyId()

  return (
    <Container>
      <GlobalMediaTypes configScope="AGENCY" configOwnerId={agencyId} />
    </Container>
  )
}

export default AgencyMediaTypes
